import produce from 'immer';
import Value from '../../models/Value';
var MAX_HISTORY_ITEMS = 100;

function isValidOperation(operation) {
  return !['setSelection', 'setData', 'undo', 'redo'].includes(operation.action.type);
}

function save(database, operations) {
  var history = database.history,
      tmp = database.tmp;

  if (!tmp.save) {
    return;
  }

  var operationsToSave = operations.filter(isValidOperation);

  if (operationsToSave.length === 0) {
    return;
  } // Clear the redos and update the history.


  database.setHistory(produce(history, function (draftHistory) {
    draftHistory.undos.push(operationsToSave);

    if (draftHistory.undos.length > MAX_HISTORY_ITEMS) {
      draftHistory.undos = draftHistory.undos.slice(0, MAX_HISTORY_ITEMS); // Constrain the history to 100 entries for memory's sake.
    }

    draftHistory.redos = [];
  }));
}

function redo(database) {
  var history = database.history;
  var batch = database.history.redos.slice(-1)[0];
  if (!batch) return;
  database.withoutSaving(function () {
    batch.forEach(function (_ref) {
      var changes = _ref.changes,
          inverseChanges = _ref.inverseChanges;
      database.applyChanges({
        action: {
          type: 'redo'
        },
        value: Value.applyPatches(database.value, changes),
        changes: changes,
        inverseChanges: inverseChanges
      });
    });
  });
  database.setHistory(produce(history, function (draftHistory) {
    draftHistory.redos.pop();
    draftHistory.undos.push(batch);
  }));
}

function undo(database) {
  var history = database.history;
  var batch = database.history.undos.slice(-1)[0];
  if (!batch) return;
  database.withoutSaving(function () {
    batch.forEach(function (_ref2) {
      var changes = _ref2.changes,
          inverseChanges = _ref2.inverseChanges;
      database.applyChanges({
        action: {
          type: 'undo'
        },
        value: Value.applyPatches(database.value, inverseChanges),
        changes: inverseChanges,
        inverseChanges: changes
      });
    });
  });
  database.setHistory(produce(history, function (draftHistory) {
    draftHistory.undos.pop();
    draftHistory.redos.push(batch);
  }));
}

export default {
  commands: {
    save: save,
    undo: undo,
    redo: redo
  }
};